import { Component, inject } from '@angular/core';
import { EnvService } from '../../../env.service';

@Component({
  selector: 'taly-partner-banner',
  templateUrl: './partner-banner.component.html',
  styleUrls: ['./partner-banner.component.scss'],
  standalone: false,
})
export class PartnerBannerComponent {
  public envService = inject(EnvService);
}
